import axios from 'axios';
import { getApiInstance } from '../api';

interface ContactFormDto {
  name: string;
  phone: string;
  email: string;
  document: string;
  message: string;
}

export const sendContactEmail = async (userInput: ContactFormDto) => {
  const api = getApiInstance();
  try {
    await api.post(`/contact`, userInput);

    return { success: true };
  } catch (error) {
    console.error(error);

    if (axios.isAxiosError(error) && error.response?.status) {
      if (error.response?.status === 400) {
        const apiMessage = error?.response?.data?.message;
        const arrayOfMessages =
          typeof apiMessage === 'string' ? [apiMessage] : apiMessage || [];
        const message = ['Erro ao enviar mensagem.', ...arrayOfMessages].join(
          ' ',
        );
        return {
          success: false,
          message,
        };
      }
      return {
        success: false,
        message: `Erro ao enviar mensagem. ${error.response?.data.message}`,
      };
    }

    return {
      success: false,
      message: `Erro ao enviar mensagem. Erro desconhecido: ${
        (error as Error).message
      }`,
    };
  }
};
